import { ArticleCardList, ArticleCardListProps } from '../ArticleCardList'
import { NewsletterSignup } from '../../../banners/NewsletterSignup/NewsletterSignup'
import React from 'react'
import { AdUnitWrapper } from '../../../advertising'
import { AdDefinition, AdEvent, AdState } from '@news-mono/web-common'
import { CollectionEvent } from '../../../../../web-common/tsc-out/events/collection-events'

export type JournoProfileArticleCardListProps = Omit<
    ArticleCardListProps,
    'interlacedComponents'
> & {
    adUnits: number
    api: string
    adState: AdState
    onEvent: (event: CollectionEvent | AdEvent) => void
}

const INITIAL_AD_OFFSET = 5
const CARDS_BETWEEN_ADS = 5
const getAdUnitId = (index: number) => `article-list-${index}`

// Builds an array of the AdUnitDefinitions.
export const getJournoProfileAdUnitDefinitions = (adUnitAmount: number) =>
    Array.from(
        { length: adUnitAmount },
        (_, i) => INITIAL_AD_OFFSET + i * CARDS_BETWEEN_ADS,
    ).map<AdDefinition>((index) => ({
        id: getAdUnitId(index),
        size: 'billboardAbove1280leaderboardAbove768MrecBelow',
    }))

/**
 * An ArticleCardList configured specifically for the Journo Profile page on the nightly.
 */
export const JournoProfileArticleCardList = ({
    adUnits,
    api,
    adState,
    onEvent,
    ...props
}: JournoProfileArticleCardListProps) => {
    return (
        <ArticleCardList
            {...props}
            onEvent={onEvent}
            interlacedComponents={{
                'newsletter-promo': {
                    component: () => (
                        <NewsletterSignup
                            text="Sign up to The Nightly's newsletters."
                            subText="Get the first look at the digital newspaper, curated daily stories and breaking headlines delivered to your inbox."
                            buttonLabel="Get the Newsletter"
                            api={api}
                            onEvent={() => {}}
                            mode={'default'}
                        />
                    ),
                    initialOffset: 3,
                },
                adverts: {
                    component: (index) => (
                        <AdUnitWrapper
                            adState={adState}
                            onEvent={onEvent}
                            noticePosition={'above-center'}
                            adType={'inline'}
                            unitId={getAdUnitId(index)}
                        />
                    ),
                    initialOffset: INITIAL_AD_OFFSET,
                    cardsBetween: CARDS_BETWEEN_ADS,
                    repetitions: adUnits,
                },
            }}
        />
    )
}
